import {useChannelsModel} from "../../../entities/useChannels.js";
import {Button, Checkbox, Spin, Row, Col, Modal} from "../../../../__snowpack__/pkg/antd.js";
import ChannelIcon from "../../../components/ChannelIcon.js";
import {isEmpty} from "../../../../__snowpack__/pkg/lodash.js";
import React, {useEffect, useState} from "../../../../__snowpack__/pkg/react.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
import {useShopsModel} from "../../../entities/useShops.js";
import {request} from "../../../utils/request/index.js";
export const AddStoreModal = (props) => {
  const {defaultIdList, handleCallBack, formatMessage, visible, filterMultWarehouse} = props;
  const [defaultIds, setDefaultIds] = useState(defaultIdList);
  const [selectedChannel, setSelectedChannel] = useState([]);
  const [selectedChannelName, setSelectedChannelName] = useState("");
  const [selectedCountryName, setSelectedCountryName] = useState("");
  const [countryList, setCountryList] = useState([]);
  const {fetchShops, shopsLoading} = useShopsModel();
  const {fetchChannels} = useChannelsModel();
  const [listLoading, setListLoading] = useState(false);
  const getChannelList = async () => {
    let data = await fetchChannels();
    data = data?.filter((item) => item.id !== "MANUAL_ID");
    fetchShopData({}, defaultIds, data);
  };
  useEffect(() => {
    getChannelList();
  }, [defaultIds]);
  const getCountryList = async () => {
    const data = await request.get("/saas/shop/list-country-of-store");
    setCountryList(data);
  };
  useEffect(() => {
    if (visible) {
      getCountryList();
    }
  }, [visible]);
  const fetchShopData = async (params, defaultIds2, channelList) => {
    const fetchData = {
      selectedChannel: params?.channelId
    };
    if (params?.countryId) {
      fetchData.countryCode = params.countryId;
    }
    const {shops} = await fetchShops({page: 0, pageSize: 1e3}, {...fetchData});
    let tempSelectedChannel = [];
    if (params?.channelId) {
      tempSelectedChannel = channelList.map((channel) => {
        if (channel.id == params?.channelId) {
          channel.list = shops;
          channel.list.map((item) => item.checked = channel.shopIdList.includes(item.shopId));
        }
        return channel;
      });
    } else {
      tempSelectedChannel = channelList?.map((channel) => {
        channel.shopIdList = channel.shopIdList || [];
        channel.list = shops.reduce((prev, item) => {
          if (item.channelId === channel.id) {
            if (defaultIds2 && defaultIds2.length > 0) {
              if (defaultIds2.includes(item.shopId)) {
                item.checked = true;
                channel.shopIdList.push(item.shopId);
              }
            } else {
              if (channel.shopIdList.includes(item.shopId)) {
                item.checked = true;
              }
            }
            prev.push({...item});
          }
          return prev;
        }, []);
        let isCheckedAll = channel?.list?.every((child) => child?.checked);
        channel.indeterminate = channel?.shopIdList?.length > 0 && !isCheckedAll;
        channel.checkAll = isCheckedAll;
        return channel;
      }) || [];
    }
    setSelectedChannel([...tempSelectedChannel]);
  };
  const changeItemChecked = (shopIdList, channel) => {
    let selectChannelItem = selectedChannel.find((item) => item.id === channel.id) || {};
    selectChannelItem.list = selectChannelItem?.list?.map((child) => {
      child.checked = shopIdList.includes(child.shopId);
      return child;
    });
    selectChannelItem.shopIdList = shopIdList;
    let isCheckedAll = selectChannelItem?.list?.every((child) => child?.checked);
    selectChannelItem.indeterminate = shopIdList.length > 0 && !isCheckedAll;
    selectChannelItem.checkAll = isCheckedAll;
    setSelectedChannel([...selectedChannel]);
  };
  const onCheckAllChange = (e, channel) => {
    let selectChannelItem = selectedChannel.find((item) => item.id === channel.id) || {};
    let tempShopIdList = [];
    selectChannelItem.list = selectChannelItem?.list?.map((child) => {
      child.checked = e.target.checked;
      child.checked && tempShopIdList?.push(child?.shopId);
      return child;
    });
    selectChannelItem.shopIdList = tempShopIdList;
    selectChannelItem.indeterminate = false;
    selectChannelItem.checkAll = e.target.checked;
    setSelectedChannel([...selectedChannel]);
  };
  const storeDoms = (channel) => {
    if (isEmpty(channel.list)) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null);
    }
    return /* @__PURE__ */ React.createElement("div", {
      className: "select-conditions"
    }, /* @__PURE__ */ React.createElement("div", {
      className: "select-subTitle"
    }, /* @__PURE__ */ React.createElement("span", {
      className: "title"
    }, channel.name), /* @__PURE__ */ React.createElement(Checkbox, {
      indeterminate: channel.indeterminate,
      onChange: (e) => onCheckAllChange(e, channel),
      checked: channel.checkAll
    }, "All")), /* @__PURE__ */ React.createElement(Checkbox.Group, {
      value: channel?.shopIdList,
      onChange: (e) => {
        changeItemChecked(e, channel);
      }
    }, /* @__PURE__ */ React.createElement("div", {
      className: "select-subContent"
    }, !isEmpty(channel.list) && channel.list?.filter((item) => {
      return item.multiWarehouse === false || !filterMultWarehouse;
    }).map((item, index) => /* @__PURE__ */ React.createElement("div", {
      className: "conditions"
    }, /* @__PURE__ */ React.createElement(Checkbox, {
      checked: item.checked,
      value: item.shopId
    }), /* @__PURE__ */ React.createElement("div", {
      className: "nameContent"
    }, /* @__PURE__ */ React.createElement(ChannelIcon, {
      channelId: item?.channelId
    }), /* @__PURE__ */ React.createElement("span", {
      style: {margin: "0 4px"}
    }, "(", item.countryCode, ")"), /* @__PURE__ */ React.createElement("span", {
      className: "name"
    }, item.shopName || item.name)))))));
  };
  return /* @__PURE__ */ React.createElement(Modal, {
    visible,
    width: 800,
    title: formatMessage({id: "storeAdd"}),
    onCancel: () => {
      handleCallBack(false);
      setDefaultIds([]);
    },
    footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
      type: "default",
      onClick: () => {
        handleCallBack(false);
        setDefaultIds([]);
      }
    }, /* @__PURE__ */ React.createElement("span", null, formatMessage({id: "cancel"}))), /* @__PURE__ */ React.createElement(Button, {
      type: "primary",
      onClick: () => {
        let select = [];
        let selectedList = selectedChannel.reduce((prev, item) => {
          item?.list?.map((val) => {
            if (item?.shopIdList?.includes(val.shopId)) {
              prev.push({
                id: val.shopId,
                name: val.shopName,
                countryCode: val.countryCode,
                channelId: val.channelId,
                multiWarehouse: val.multiWarehouse
              });
            }
          });
          return prev;
        }, []);
        if (filterMultWarehouse) {
          selectedList = selectedList.filter((item) => !item.multiWarehouse);
        }
        handleCallBack(true, selectedList);
      }
    }, /* @__PURE__ */ React.createElement("span", null, formatMessage({id: "save"}))))
  }, /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Spin, {
    spinning: shopsLoading
  }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: 2
  }, /* @__PURE__ */ React.createElement("span", {
    className: "channel-name"
  }, formatMessage({id: "channelName"}), "\uFF1A")), /* @__PURE__ */ React.createElement(Col, {
    span: 22
  }, /* @__PURE__ */ React.createElement("ul", {
    className: "channel-list"
  }, /* @__PURE__ */ React.createElement("li", {
    className: !selectedChannelName ? "active" : "",
    onClick: () => {
      setSelectedChannelName("");
      fetchShopData({}, [], selectedChannel);
    }
  }, formatMessage({id: "globalStatus_all"})), !isEmpty(selectedChannel) && selectedChannel.map((item) => {
    return /* @__PURE__ */ React.createElement("li", {
      className: selectedChannelName && selectedChannelName === item.id ? "active" : "",
      onClick: () => {
        setSelectedChannelName(item.id);
        fetchShopData({channelId: item.id, countryId: selectedCountryName}, [], selectedChannel);
      }
    }, item.name);
  })))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: 2
  }, /* @__PURE__ */ React.createElement("span", {
    className: "channel-name"
  }, formatMessage({id: "country"}), "\uFF1A")), /* @__PURE__ */ React.createElement(Col, {
    span: 22
  }, /* @__PURE__ */ React.createElement("ul", {
    className: "channel-list"
  }, /* @__PURE__ */ React.createElement("li", {
    className: !selectedCountryName ? "active" : "",
    onClick: () => {
      setSelectedCountryName("");
      fetchShopData({}, [], selectedChannel);
    }
  }, formatMessage({id: "globalStatus_all"})), !isEmpty(countryList) && countryList?.map((item) => {
    return /* @__PURE__ */ React.createElement("li", {
      className: selectedCountryName && selectedCountryName === item ? "active" : "",
      onClick: () => {
        setSelectedCountryName(item);
        fetchShopData({channelId: selectedChannelName, countryId: item}, [], selectedChannel);
      }
    }, item);
  })))), /* @__PURE__ */ React.createElement(Spin, {
    spinning: listLoading
  }, selectedChannelName ? storeDoms(selectedChannel.filter((item) => item.id === selectedChannelName)[0]) : selectedChannel.map((item) => storeDoms(item))))));
};
const Wrapper = styled.div`
  height: 400px;
  overflow: overlay;
  /* == auto auto 会占用 overlay  */
  .ant-form-inline {
    width: 600px;
  }
  .channel-name {
    font-size: 12px;
    font-weight: 400;
    color: #1c1953;
    padding: 3px;
    display: inline-block;
  }
  .channel-list {
    padding: 0;
    margin: 0 0 12px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    li {
      list-style: none;
      font-size: 12px;
      font-weight: 400;
      color: #606c80;
      line-height: 18px;
      padding: 3px 12px;
      cursor: pointer;
    }
    .active {
      background: #6020ff;
      border-radius: 3px;
      color: #fff;
    }
  }
  .warehouse-select {
    background: #ffffff;
    border-radius: 3px 0px 0px 3px;
    border: 1px solid #adbacc;
    width: 19%;
  }
  .select-conditions {
    min-height: 66px;
    /* border: 1px solid #dfe3e8; */
    background: #f7f8fa;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: start;
    position: relative;
    padding: 24px 16px 0px 16px;
    flex-wrap: wrap;
    margin-bottom: 12px;
    .select-subTitle {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .title {
        height: 20px;
        font-size: 14px;
        font-family: PingFangTC-Semibold, PingFangTC;
        font-weight: 600;
        color: #202d40;
        line-height: 20px;
        margin-right: 16px;
      }
    }
    .select-subContent {
      display: flex;
      flex-wrap: wrap;
      .conditions {
        height: 28px;
        border-radius: 4px;
        margin: 0 9px 9px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .select-checkbox {
          width: 14px;
          height: 14px;
          position: relative;
          top: -1px;
        }
        .nameContent {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          margin-left: 8px;
        }
        .name {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 20px;
          font-size: 13px;
          font-weight: 400;
          color: #202d40;
          line-height: 20px;
        }
        .no-store {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
`;
